import React from "react";

export default function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-16">
      <div className="text-xs uppercase tracking-widest text-brand-red font-semibold mb-3">Legal</div>
      <h1 className="font-display text-4xl md:text-5xl font-bold">Terms & Conditions</h1>
      <p className="text-muted-foreground mt-3 text-sm">Last updated: February 2026</p>

      <div className="mt-8 space-y-6 text-sm leading-relaxed">
        <p>
          By registering as a participant of the <strong>Indonesia-Japan Friendship Festival 2026 (IJFF 2026)</strong>, you agree to the following:
        </p>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">1. Booking commitment</h2>
          <p>Registration is a commitment to participate on <strong>12 – 13 December 2026</strong> at Shiokaze Park, Odaiba, Tokyo.</p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">2. Deposit policy</h2>
          <p>
            Where a deposit is required (Performers and booth participants), the deposit will be requested after registration
            is approved. It is <strong>refundable within 14 days after the event</strong>, subject to confirmed participation
            and compliance with the organizer&apos;s rulebook.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">3. Cancellation</h2>
          <p>
            Cancellation less than 30 days before the event forfeits 100% of the deposit.
            Earlier cancellations are reviewed case-by-case.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">4. Food safety (F&B booths)</h2>
          <p>
            Food and catering participants must comply with the Japanese Food Sanitation Law (食品衛生法) and hold or acquire
            a Food Sanitation Manager certification (食品衛生責任者). The organizer may inspect and refuse operation of any
            non-compliant booth without refund.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">5. Facilities</h2>
          <p>
            Standard booth equipment is 2 tables + 4 chairs unless otherwise specified. Additional facilities
            (gas, water, refrigerator, sink) will be provided only for participants who declared them at registration.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">6. Content standards</h2>
          <p>
            Performances and displayed content must be respectful of Indonesian and Japanese cultural sensitivities.
            The organizer reserves the right to modify the rundown for operational reasons.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">7. Data & privacy</h2>
          <p>
            Personal and business data submitted through this website is confidential. Only the organizer team and
            the registrar themselves can view submitted data. It will not be shared with third parties without written consent.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">8. Media consent</h2>
          <p>
            Photos and video captured during the event may be used for IJFF marketing and post-event reporting.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">9. Force majeure</h2>
          <p>
            In case of natural disaster, epidemic, or government restriction preventing the event, deposits will be
            fully refunded.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl font-bold mb-2">10. Governing law</h2>
          <p>
            Any dispute will be governed by the laws of Japan and settled in Tokyo District Court.
          </p>
        </section>
      </div>
    </div>
  );
}
